<div class="dropdown-control d-flex justify-center align-items-center clickable" (click)="toggleAccountSettingMenu()">
  <div class="display-container d-flex justify-center fv-item new-sidebar-icon">
    <span [class.isDropdownOpen]="isDropdownOpen">
      <i phx-icon class="user-name" [phxIcon]="avatarIcon"></i>
    </span>
  </div>
</div>
<div class="content dropdown">
  <div class="user-info">
    <div class="username-fullname semi-bold-18">{{userName}}</div>
    <div class="user-email-address regular-12">{{userEmail}}</div>
  </div>
  <div class="divider"></div>
  <div class="feature-upgrade" *ngIf="showUpgradeToPro" (click)="generalUpgradeModal.show($event)">
    {{upsellLabel}}
  </div>
  <company-switcher *ngIf="isCompanySwitcherEnabled"></company-switcher>
  <div *ngIf="showUpgradeToPro && !canSwitchCompany" class="divider"></div>
  <div [class.bg-dark]="showUpgradeToPro || canSwitchCompany" class="links d-flex justify-space-between align-items-center">
    <div *ngIf="isFleetCardsFleetUserCardsEnabled">
      <button *ngIf="myCardModuleLoaded && userHasActiveFleetUserCard" phx-button phxButtonRole="secondary" class="mr-8" (click)="showMyCardDrawer()">
        <ng-container i18n>My Card</ng-container>
      </button>
      <a routerLink="/settings" phx-button phxButtonRole="secondary" (click)="reloadSettings()" >
        <ng-container i18n>Account Settings</ng-container>
      </a>
      <a routerLink="/logout" phx-button phxButtonRole="secondary" class="ml-8">
        <ng-container i18n>Logout</ng-container>
      </a>
    </div>
    <div *ngIf="!isFleetCardsFleetUserCardsEnabled">
      <a routerLink="/settings" nz-button nzTrigger="click" nzType="default" class="link-item" (click)="reloadSettings()" >
        <ng-container i18n>Account Settings</ng-container>
      </a>
      <a routerLink="/logout" nz-button nzTrigger="click" nzType="default" class="ml-10 link-item">
        <ng-container i18n>Logout</ng-container>
      </a>
    </div>
  </div>
  <div class="app-version regular-12">
    <ng-container i18n>Version</ng-container> {{clientAppVerion}}
  </div>
</div>

<general-upgrade-modal #generalUpgradeModal *ngIf="isUpsellEnabled" featureKeyName="general_upgrade" componentName="general-upgrade">
</general-upgrade-modal>